import {
  pgTable,
  text,
  timestamp,
  uuid,
  jsonb,
  index,
  uniqueIndex,
} from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";

const tz = { withTimezone: true } as const;

export const platformConsentRecords = pgTable(
  "platform_consent_records",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    personId: uuid("person_id").notNull(),
    purpose: text("purpose").notNull(),
    legalBasis: text("legal_basis").notNull(),
    grantedAt: timestamp("granted_at", tz).notNull().defaultNow(),
    withdrawnAt: timestamp("withdrawn_at", tz),
    source: text("source").notNull(),
    policyVersion: text("policy_version").notNull(),
    ipAddressHash: text("ip_address_hash"), // HMAC-SHA-256 (IP_HASH_SECRET) — never raw IP (GDPR). Column renamed from ip_address.
    proof: jsonb("proof").notNull().default({}),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    uniqueIndex("uq_consent_tenant_contact_purpose").on(
      table.tenantId,
      table.personId,
      table.purpose,
    ),
    index("idx_consent_tenant_contact").on(table.tenantId, table.personId),
    index("idx_consent_tenant_active")
      .on(table.tenantId)
      .where(sql`withdrawn_at IS NULL`),
  ],
);
